<section class="p-2">
  <div class="suggestions-grid">
    <div>
      <p
        class="text-muted mb-1 font-weight-bold"
        i18n="
          searchBar|Text for suggested
          products@@searchBarSuggestedProductsHeader"
      >
        Suggested Products
      </p>
      @if (products()?.length > 0) { @for (product of products(); track
      product.productId) {
      <div
        class="d-flex my-1 product-item p-1 cursor-pointer"
        (click)="onProductClick(product)"
      >
        <div class="position-relative">
          <atx-image
            [imageUrl]="product.mainImageUrl"
            [maxWidth]="imageMaxSize"
            failedLoadIconSize="1x"
            fallbackImageUrl="static/images/placeholder-image.jpg"
          ></atx-image>
          @if (product.priceRanges[0]?.discount?.max > 0) {
          <atx-discount-label
            *atxCanShowByWsp
            class="badge-success"
            [discount]="product.priceRanges[0].discount"
          ></atx-discount-label>
          }
        </div>

        <div
          class="align-self-center d-flex flex-column pr-1 pl-3 pl-lg-3 pl-xxl-3"
        >
          <div class="d-flex align-items-center">
            <span class="font-weight-bold mr-2">{{
              product
                | productTitle: { fields: idFields() }
                | productId: productIdAdditionalPrefixRexExp()
            }}</span>

            <atx-product-labels
              [productLabels]="product.labels | filterLabelsByName: 'discount'"
              [location]="labelsLocation"
              [shownLabelsLimit]="3"
            ></atx-product-labels>
          </div>

          <atx-product-card-title
            [product]="product"
            [titleFields]="titleFields()"
          ></atx-product-card-title>
          <atx-product-prices
            [prices]="product.priceRanges[0]"
            [showWholeSalePrices]="showWholeSalePrices()"
            [showMarkup]="showMarkupPrice()"
            [showWspdPrice]="showWspdPrice()"
          ></atx-product-prices>
        </div>
      </div>
      } } @else {
      <span
        i18n="
          searchBar|Text for no suggested products@@searchBarNoSuggestedProducts"
      >
        No suggested products...
      </span>
      <ng-content></ng-content>
      }
    </div>
    @if(hasAutocomplete() || hasFilters()) {
    <div>
      @if (hasAutocomplete()) {
      <dl>
        <dt
          class="text-muted mb-1"
          i18n="
            searchBar|Text for suggested autocomplete
            text@@searchBarSuggestedTextHeader"
        >
          Maybe you mean
        </dt>
        @for (text of autocompletesFlattened(); track text) {
        <dd
          class="pl-2 py-1 mb-0 search-suggest-item"
          (click)="onAutocompleteClick.emit(text)"
        >
          {{ text }}
        </dd>
        }
      </dl>
      } @if (hasFilters()) {
      <dl>
        <dt
          class="text-muted mb-1"
          i18n="
            searchBar|Text for suggested filter@@searchBarSuggestedFiltersHeader"
        >
          Filters
        </dt>
        @for (filterItem of mappedFilters(); track filterItem.filterField) {
        <dd class="d-flex flex-column mb-1">
          <dl class="mb-0">
            <dt class="my-1">
              {{ filterItem | filterDisplayName }}
            </dt>
            @for (value of filterItem.options; track value.text) {
            <dd
              (click)="
                onFilterItemClick(
                  value.text,
                  filterItem.filterField,
                  value.isActive
                )
              "
              class="pl-2 py-1 mb-0 search-suggest-item"
            >
              {{ value.text }}
            </dd>
            }
          </dl>
        </dd>
        }
      </dl>
      }
    </div>
    }
  </div>
</section>
